import React, {useEffect, useState} from 'react';

// @ts-ignore
const FailPopUp = ({message, setFailPopUp}) => {
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsOpen(false);
            setFailPopUp(false)
        }, 3000);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div
            className={`${
                isOpen ? 'translate-x-0' : 'translate-x-[120%]'
            } fixed bottom-5 right-5 transition-transform duration-500 ease-in-out z-50 bg-white rounded-2xl`}
        >
            <div className=" p-4 border border-gray-200 rounded-2xl flex space-x-1 items-center border-b-4 border-b-red-600">
                <div className="mr-2"/>
                <h1 className="text-gray-800">Failed!</h1>
                <p className="text-gray-800 text-md">{message}</p>
            </div>
        </div>
    );
};

export default FailPopUp;